import React from 'react';
import Button from "@mui/material/Button";
import { DEFAULT_THEME_COLOR } from "../../constants/theme";
import DownloadIcon from "@mui/icons-material/Download";
import useTranslation from "../../customHooks/translations";

const DownloadGpxComponent = (props) => {
  const translation = useTranslation();

  const normalizeCoordinates = (data) => {
    if (Array.isArray(data)) {
      return data;
    }

    if (typeof data === 'string') {
      const values = data.split(',');

      const coords = [];

      for (let i = 0; i < values.length; i += 2) {
        const lat = parseFloat(values[i]);
        const lng = parseFloat(values[i + 1]);

        if (!isNaN(lat) && !isNaN(lng)) {
          coords.push([lat, lng]);
        }
      }

      return coords;
    }

    return [];
  };

  const generateGpx = (coordinates) => {
    const points = coordinates.map(([lat, lng]) => `
      <trkpt lat="${lat}" lon="${lng}"></trkpt>
    `);

    return `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1"
     creator="Freakland"
     xmlns="http://www.topografix.com/GPX/1/1">
  <trk>
    <name>Route</name>
    <trkseg>
      ${points.join('')}
    </trkseg>
  </trk>
</gpx>`;
  };

  const handleDownload = () => {
    if (!props.gpx) {
      console.error('No GPX data');
      return;
    }

    const coordinates = normalizeCoordinates(props.gpx);

    if (!coordinates.length) {
      console.error('Invalid GPX coordinates');
      return;
    }

    const gpxContent = generateGpx(coordinates);

    const blob = new Blob([gpxContent], {
      type: 'application/gpx+xml',
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${props.fileName || 'route'}.gpx`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  };

  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      style={{
        minWidth: 150,
        maxWidth: 300,
        backgroundColor: DEFAULT_THEME_COLOR,
        color: 'white',
        borderRadius: 4,
        margin: 10,
        marginLeft: 10,
      }}
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
    >
      {translation.buttons.downloadGpx}
    </Button>
  );
};

export default DownloadGpxComponent;
